import styled from 'styled-components';
import { DropdownItem } from '@optimus-web/core';

interface OwnProps {
    inactive?: boolean;
}

export const OrderItemIconMenuItem = styled(DropdownItem)<OwnProps>`
    &:hover {
        ${(props) =>
            props.inactive &&
            `
            cursor: not-allowed;
        `}
    }
`;
